import { type } from 'arktype';

export const APPLICATION_FUNCTIONALITY = [
  'ROLE_MANAGE_USER',
  'ROLE_MANAGE_CUSTOMER',
  'ROLE_MANAGE_PAYMENT_CONTACTS',
  'ROLE_CREATE_TRANSACTIONS',
  'ROLE_VIEW_ACTIVITY',
  'ROLE_RECEIVE_TRANSACTION_STATUS_NOTIFICATIONS',
] as const;

export const groupSchema = type({
  groupName: type('string>0').configure({ message: 'VALIDATION_REQUIRED' }),
  description: type('string'),
  roles: type(`("${APPLICATION_FUNCTIONALITY.join('" | "')}")[]>=1`),
}).readonly();

export type GroupFormData = typeof groupSchema.infer;
